import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";

import { Action, NgxsOnInit, State, StateContext } from "@ngxs/store";
import { Vehicle } from "../../core/models";
import { updateEntities } from "../utils";
import { dispatchRequest } from "../dispatch-request";
import {
  LoadCustomerVehiclesAction,
  LoadCustomerVehiclesSuccessAction,
  UpdateVehicleAfterUpdatingItsInfoAction,
} from "./vehicle.actions";
import {
  defaultRequestState,
  IRequestsNestedState,
} from "../interfaces/requests.interface";

export interface VehicleStateModel {
  entities: { [key: number]: Vehicle };
  ids: number[];
  customerVehiclesIds: number[];
  customerVehiclesRequestState: IRequestsNestedState;
}

@State<VehicleStateModel>({
  name: "vehicle",
  defaults: {
    entities: {},
    ids: [],
    customerVehiclesIds: [],
    customerVehiclesRequestState: { ...defaultRequestState },
  },
})
@Injectable()
export class VehicleState implements NgxsOnInit {
  constructor(private httpClient: HttpClient) {}

  ngxsOnInit(ctx: StateContext<VehicleStateModel>) {}

  @Action(LoadCustomerVehiclesAction)
  loadCustomerVehicles(
    ctx: StateContext<VehicleStateModel>,
    action: LoadCustomerVehiclesAction
  ) {
    const request = this.httpClient.get("GetCustomerVehicles");

    // customerVehiclesRequestState is deliberately left unwritten:
    // CustomerVehiclesResolver skips the reload once `loaded` is true, so
    // starting to write it would change how often the fleet is refetched.
    return dispatchRequest(request, ctx, LoadCustomerVehiclesSuccessAction);
  }

  @Action(LoadCustomerVehiclesSuccessAction)
  loadCustomerVehiclesSuccess(
    ctx: StateContext<VehicleStateModel>,
    action: LoadCustomerVehiclesSuccessAction
  ) {
    const stateUpdate = updateEntities(action.payload, Vehicle);
    ctx.patchState({
      entities: {
        ...ctx.getState().entities,
        ...stateUpdate.entities,
      },
      ids: [...ctx.getState().ids, ...stateUpdate.ids],
      customerVehiclesIds: stateUpdate.ids,
    });
  }

  @Action(UpdateVehicleAfterUpdatingItsInfoAction)
  updateVehicleAfterUpdatingItsInfo(
    ctx: StateContext<VehicleStateModel>,
    action: UpdateVehicleAfterUpdatingItsInfoAction
  ) {
    const vehicleId = action.payload.id;
    const { entities } = ctx.getState();

    if (entities[vehicleId]) {
      ctx.patchState({
        entities: {
          ...entities,
          [vehicleId]: {
            ...entities[vehicleId],
            ...action.payload,
          },
        },
      });
    }
  }
}
